import { render, staticRenderFns } from "./search-task.vue?vue&type=template&id=406f62cb&scoped=true&"
import script from "./search-task.vue?vue&type=script&lang=js&"
export * from "./search-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f62cb",
  null
  
)

export default component.exports